import { gql } from 'graphql-tag'

export default gql`
  fragment ModuleTerminalHardwareSpecsFragment on ModuleTerminalHardwareSpecs {
    dimensions
    deviceVariant
    printer
    userInterface
    paperRollSize
    speakerAudio
    weight
    battery
    processor
    memory
    powerSupply
    operatingSystem
    camerabarcodeScanner
    pciValidity: pciValidityFromList
    p2pe: p2Pe
  }
`
